import BaseApi from "../../../services/Api";
import Swal from "sweetalert2";
import React, {useEffect, useState} from "react";
import Tooltip from "../../Popups/Tooltip";
import {Modal, Spinner} from "react-bootstrap";
import { format } from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';

import { useSearchParams } from "react-router-dom";
import {toast} from "react-toastify";

const INITIAL_DATA = {
  total: 0,
  current_page: 1,
  last_page: 1,
  first_page_url: "",
  last_page_url: "",
  next_page_url: "",
  prev_page_url: null,
  path: "",
  from: 1,
  to: 1,
  data: [],
};


const ModalSuitorInfo = ({
  idSuitor, children
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const [isSaving, setSaving] = React.useState(true);
  const [isShow, setShowModal] = React.useState(false);

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = React.useState('');
  const [choice, setChoice] = React.useState('');
  const [animal_id, setAnimal_id] = React.useState('');
  const [creationDate, setCreationDate] = useState('');
  const [animalName, setAnimalName] = useState("");


  const handleClose = () => {
    setShowModal(false);
  }

  const requestData = () => {
    setLoading(true);
    BaseApi.get(`/pretendente/${idSuitor}`).then(res => {

      let data = res.data;
      setAnimalName(data?.animal?.name);
      setName(data.name);
      setAddress(data.address);
      setPhone(data.phone);
      setEmail(data.email);
      setChoice(data.choice);
      setAnimal_id(data.animal_id);
      setCreationDate(data.created_at);
      setLoading(false);
      setSaving(false);
    }).catch(err => {
      console.log(err);
      Swal.fire('Oops!', err?.data?.errors?.[0] || err?.data?.message || 'Ocorreu um erro ao carregar este usuario ou o usuário não foi encontrado.', 'error');
      setShowModal(false);
    })
  }



    /*Requisição de dados dos animais nao adoados*/
    let [searchParams, setSearchParams] = useSearchParams();

    let controller = new AbortController();

    const INITIAL_FILTERS = {
        search: searchParams.get("search") || "",
    };

    const INITIAL_QUERY = {
        sort: "id",
        order: "desc",
        per_page: 10,
        page: searchParams.get("page") || 1,
    };

    const [isFiltering, setFiltering] = React.useState(true);
    const [isPaginating, setPaginating] = React.useState(true);

    const [query, setQuery] = React.useState({
        ...INITIAL_QUERY,
        ...INITIAL_FILTERS,
    });
    const [filters, setFilters] = React.useState({ ...INITIAL_FILTERS });
    const [animalsData, setAnimalsData] = React.useState({ ...INITIAL_DATA });


  const requestanimalsData = (args = {}) => {
    setLoading(true);
    let q = { ...query, ...args };
    BaseApi.get("/animais_naoadotados", {
    signal: controller.signal,
    params: {
        ...q,
        search: q.search !== "" ? q.search : undefined,
    },
    })
    .then((response) => {
        setAnimalsData(response.data);
        setLoading(false);
        setPaginating(false);
        setFiltering(false);
    })
    .catch((err) => {
        if (err) {
        console.log(err);
        toast.error("Erro ao carregar dados da tabela");
        setAnimalsData({ ...INITIAL_DATA });
        setLoading(false);
        setPaginating(false);
        setFiltering(false);
        }
    });
}; /*Fim da requisição */

  useEffect(() => {
    if(isShow) {
      requestData();
      requestanimalsData();
    } else {
      setName('');
      setAddress('');
      setPhone('');
      setEmail('');
      setChoice('');
      setAnimal_id('');
      setAnimalName('');
      setLoading(true);
      setSaving(true);
    }
  }, [isShow])

  return (
    <>
      {children &&
        React.cloneElement(children, { onClick: (e) => setShowModal(true) })}
      {!children && (
        <Tooltip text={"Informações do Pretendente"}>
          <button
            className={`btn btn-${idSuitor ? "warning" : ""} text-white fa-bold`}
            onClick={(e) => setShowModal(true)}
          >
            <i className={`bi bi-${idSuitor ? "person-gear" : "plus"}`}></i>
          </button>
        </Tooltip>
      )}
      <Modal
        centered
        scrollable
        onHide={handleClose}
        show={isShow}
        animation={true}
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>Informações do Pretendente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center justify-content-center">
            {isLoading && (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            )}
          </div>
          {!isLoading && (
            <>
              <div className="row">
                
                <div className="form-group mb-3">
                  <label htmlFor="name">Nome</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    placeholder="nome"
                    value={name}
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="address">Endereço</label>
                  <input
                    type="address"
                    className="form-control"
                    id="address"
                    placeholder="endereço"
                    value={address}
                   
                  readonly/>
                </div>
                <div className="form-group mb-3">
                  <label htmlFor="phone">Phone</label>
                  <input
                    type="phone"
                    className="form-control"
                    id="phone"
                    placeholder="telefone"
                    value={phone}
                   
                  readonly/>
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="animal_id">Animal </label> 
                  <select value={animal_id} name="animal_id" id="animal_id" className="form-select">
                      <option value="" disabled='disabled' selected>Animal</option>

                        <option value={animal_id}>{animalName}</option>

                  </select>
                </div>
                 

                <div className="form-group mb-3">
                  <label htmlFor="choice">Adotar ou lar temporário? </label> 
                  <select value={choice} name="choice" id="choice" className="form-select">
                      <option value="" disabled='disabled' selected>Adotar ou lar temporário?</option>
                      <option value={'adopt'}>Adotar</option>
                      <option value={'home'}>Lar temporário</option>
                  </select>
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="creationDate">Data de criação</label>
                  <input
                    type="creationDate"
                    className="form-control"
                    id="creationDate"
                    value={format(new Date(creationDate), "d 'de' MMMM 'de' yyyy 'às' H:mm", { locale: ptBR })}
                   
                  readonly/>
                </div>
                




              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex align-items-center w-100">
            <div className="d-block me-auto"></div>
            <div className="d-block ms-auto">
              <button
                className="btn btn-danger text-white me-2"
                onClick={handleClose}
              >
                Close
              </button>
             
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalSuitorInfo;